import styled from "styled-components";

export const Section = styled.div`
    margin: 0 12px;
    
    & + & {
        margin-top: 5rem;
    }
`;